import Meta from "../../../components/Meta"
import Iso from '../../../components/services/consultancy/Iso27001.js';

import { useRouter } from 'next/router';
import en from '../../../contents/metas/en';
import tr from '../../../contents/metas/tr';

export default function IsoPage(props) {

  const router = useRouter();
  let t = router.locale === 'tr' ? tr : en;

  return (
    <div>
      <Meta
        title={t.iso27001.title}
        keywords={t.iso27001.keywords}
        description={t.iso27001.description}
        alternateLanguageEn={`https://${props.host}${en.iso27001.link}`}
        alternateLanguage={`https://${props.host}/tr${tr.iso27001.link}`}
         />
      <Iso datasIso={t.iso27001}/>
    </div>
  )

}

export async function getServerSideProps(context) {
  const {req} = context
  let host
  if(req.headers.host) host = req.headers.host;
  return {
    props: {
      host
    }, // will be passed to the page component as props
  }
}